
import { useState, useEffect } from "react";
import { TipoCobrancaHeader } from "./styles";
import { useConfiguracoesPedidoContext } from "../../../pedidos/contexts/ConfiguracoesPedidoContext";
import { RadioCard } from "../../../core/components/RadioCard";
import { TipoCobrancaEntrega, TipoCobrancaEntregaDescricao, TipoCobrancaEntregaTitulo } from "../../../pedidos/enum/TipoCobrancaEntrega";
import { TipoFormularioEndereco } from "../../../pedidos/enum/TipoFormularioEndereco";
import { RegioesEntregaContainer } from "./containers/RegioesEntregaContainer";
import { DistanciasEntregaContainer } from "./containers/DistanciasEntregaContainer";
import { Box, RadioGroup, Paper, Divider } from "@mui/material";


export const Entrega = () => {
    const { configuracao, alterarTipoCobrancaEntrega } = useConfiguracoesPedidoContext();
    const [tipoCobranca, setTipoCobranca] = useState<TipoCobrancaEntrega>(configuracao?.tipoCobrancaEntrega ?? TipoCobrancaEntrega.DISTANCIA);
    const [tipoFormulario, setTipoFormulario] = useState<TipoFormularioEndereco>(configuracao?.tipoFormularioEndereco ?? TipoFormularioEndereco.PADRAO);

    useEffect(() => {
        if (configuracao?.tipoCobrancaEntrega) {
            setTipoCobranca(configuracao.tipoCobrancaEntrega);
        }
        if (configuracao?.tipoFormularioEndereco) {
            setTipoFormulario(configuracao.tipoFormularioEndereco);
        }
    }, [configuracao]);

    const handleTipoCobranca = (tipo: TipoCobrancaEntrega) => {
        setTipoCobranca(tipo);
        const tipoFormularioParaEnviar = tipo === TipoCobrancaEntrega.DISTANCIA ? tipoFormulario : undefined;
        alterarTipoCobrancaEntrega(tipo, tipoFormularioParaEnviar);
    }

    const handleTipoFormulario = (tipo: TipoFormularioEndereco) => {
        setTipoFormulario(tipo);
        alterarTipoCobrancaEntrega(tipoCobranca, tipo);
    }


    return (
        <Box sx={{ width: "100%", minHeight: "180px", height: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <TipoCobrancaHeader sx={{ height: "auto", alignItems: "flex-start" }}>
                <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 0 }}>
                    <RadioGroup
                        name="tipo-cobranca-entrega"
                        row
                        sx={{ display: "flex", justifyContent: "flex-start", gap: '2rem', width: "100%" }}
                        onChange={(e) => handleTipoCobranca(e.target?.value as TipoCobrancaEntrega)}
                    >
                        <RadioCard
                            labelTitle={TipoCobrancaEntregaTitulo.DISTANCIA}
                            labelDescription={TipoCobrancaEntregaDescricao.DISTANCIA}
                            labelValue={TipoCobrancaEntrega.DISTANCIA}
                            key={TipoCobrancaEntrega.DISTANCIA}
                            selected={tipoCobranca == TipoCobrancaEntrega.DISTANCIA}
                            onClick={() => handleTipoCobranca(TipoCobrancaEntrega.DISTANCIA)}
                        />
                        <RadioCard
                            labelTitle={TipoCobrancaEntregaTitulo.REGIAO}
                            labelDescription={TipoCobrancaEntregaDescricao.REGIAO}
                            labelValue={TipoCobrancaEntrega.REGIAO}
                            key={TipoCobrancaEntrega.REGIAO}
                            selected={tipoCobranca == TipoCobrancaEntrega.REGIAO}
                            onClick={() => handleTipoCobranca(TipoCobrancaEntrega.REGIAO)}
                        />
                    </RadioGroup>
                    {tipoCobranca == TipoCobrancaEntrega.DISTANCIA && (
                        <>
                            <Divider sx={{ my: 2 }} />
                            <RadioGroup
                                name="tipo-formulario-endereco"
                                row
                                sx={{ display: "flex", justifyContent: "flex-start", gap: '2rem', width: "100%" }}
                                value={tipoFormulario}
                                onChange={(e) => handleTipoFormulario(e.target?.value as TipoFormularioEndereco)}
                            >
                                <RadioCard
                                    labelTitle="Formulário Padrão"
                                    labelDescription="Formulário tradicional com campos separados"
                                    labelValue={TipoFormularioEndereco.PADRAO}
                                    key={TipoFormularioEndereco.PADRAO}
                                    selected={tipoFormulario == TipoFormularioEndereco.PADRAO}
                                    onClick={() => handleTipoFormulario(TipoFormularioEndereco.PADRAO)}
                                />
                                <RadioCard
                                    labelTitle="Google Autocomplete"
                                    labelDescription="Busca de endereço com Google Places"
                                    labelValue={TipoFormularioEndereco.GOOGLE_AUTOCOMPLETE}
                                    key={TipoFormularioEndereco.GOOGLE_AUTOCOMPLETE}
                                    selected={tipoFormulario == TipoFormularioEndereco.GOOGLE_AUTOCOMPLETE}
                                    onClick={() => handleTipoFormulario(TipoFormularioEndereco.GOOGLE_AUTOCOMPLETE)}
                                />
                            </RadioGroup>
                        </>
                    )}
                </Box>
            </TipoCobrancaHeader>
            {tipoCobranca == TipoCobrancaEntrega.REGIAO && <RegioesEntregaContainer />}
            {tipoCobranca == TipoCobrancaEntrega.DISTANCIA && <DistanciasEntregaContainer />}
        </Box>
    )
}